import React, { useEffect, useState } from "react";
import { DatePicker, Form, Input, Select, Upload } from "antd";
import { OfferServiceService } from "../../../services/offerServiceService";
import { toast } from "react-toastify";
import SwitchComponent from "../../../components/SwitchComponent/SwitchComponent";
import dayjs from "dayjs";
import { PaymentMethods } from "../../../constants/Constants";

const { Option } = Select;

const AddOfferServiceForm = ({
  onAddOfferService,
  onEditOfferService,
  loading,
  initialValues,
}) => {
  const [form] = Form.useForm();

  const [imageList, setImageList] = useState([]);
  const [isActive, setIsActive] = useState(true); // Trạng thái mặc định là true
  console.log("imageList", imageList);

  useEffect(() => {
    // Nếu có `initialValues`, điền thông tin vào form
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        applyDate: {
          start: initialValues.applyDate?.start
            ? dayjs(initialValues.applyDate.start)
            : null,
          end: initialValues.applyDate?.end
            ? dayjs(initialValues.applyDate.end)
            : null,
        },
      });
      const formattedImages = (initialValues.images || []).map(
        (url, index) => ({
          uid: `-1-${index}`, // uid phải là chuỗi duy nhất
          name: `image-${index}.jpg`, // Tên file giả định
          status: "done",
          url: url,
        })
      );
      setImageList(formattedImages);
      setIsActive(initialValues.isActive);
    } else {
      form.resetFields();
      setImageList([]);
      setIsActive(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  const handleImageChange = ({ fileList }) => {
    // Lưu ảnh tương ứng với màu sắc
    setImageList(fileList);
  };

  const handleToggle = (newState) => {
    setIsActive(newState);
  };

  const handleSubmit = async (values) => {
    if (imageList.length === 0) {
      toast.error("Vui lòng chọn ít nhất một ảnh!");
      return;
    }
    // Phân loại ảnh cũ và ảnh mới
    // const existingImages = allImages.filter((file) => file.url); // Ảnh cũ
    const newImages = imageList.filter((file) => file.originFileObj); // Ảnh mới

    try {
      let uploadedImageUrls = [];
      if (newImages.length > 0) {
        // Gửi ảnh mới lên Cloudinary
        const formData = new FormData();
        newImages.forEach((file) => {
          formData.append("image", file.originFileObj);
        });

        const response = await OfferServiceService.uploadOfferServiceImages(
          formData
        );
        if (!response.Data) {
          toast.error("Có lỗi khi tải ảnh!");
          return;
        }
        uploadedImageUrls = response.Data.imageUrls;
      }

      // Kết hợp URL của ảnh cũ và ảnh mới theo đúng thứ tự
      const finalImageUrls = imageList.map((file) =>
        file.url ? file.url : uploadedImageUrls.shift()
      );

      const offerServiceData = {
        ...values,
        images: finalImageUrls,
        isActive: isActive,
        applyDate: {
          start: values.applyDate.start.toISOString(),
          end: values.applyDate.end.toISOString(),
        },
      };

      if (initialValues) {
        // Cập nhật sản phẩm
        await onEditOfferService(initialValues._id, offerServiceData);
        toast.success("Sản phẩm đã được cập nhật thành công!");
      } else {
        // Thêm mới sản phẩm
        await onAddOfferService(offerServiceData);
        toast.success("Sản phẩm đã được thêm thành công!");
      }
      form.resetFields();
    } catch (error) {
      toast.error("Có lỗi xảy ra!");
      console.error(error);
    }
  };

  return (
    <div className="h-[30rem] overflow-auto" form-container>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label="Tiêu đề"
          name="title"
          rules={[{ required: true, message: "Tiêu đề là bắt buộc!" }]}
        >
          <Input activeBorderColor="#000" hoverBorderColor="#000" />
        </Form.Item>
        <Form.Item
          label="Mô tả ngắn"
          name="excerpt"
          rules={[{ required: true, message: "Mô tả ngắn là bắt buộc!" }]}
        >
          <Input activeBorderColor="#000" hoverBorderColor="#000" />
        </Form.Item>

        <Form.Item
          label="Mô tả chi tiết"
          name={"description"}
          rules={[{ required: true, message: "Vui lòng nhập mô tả chi tiết!" }]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item
          label={"Ảnh minh hoạ"}
          name={"images"}
          rules={[{ required: true, message: "Thêm ít nhất một ảnh" }]}
        >
          <Upload
            name="file"
            fileList={imageList}
            beforeUpload={() => false}
            onChange={(fileList) => handleImageChange(fileList)}
            accept={[".jpg", ".png", ".jpeg", ".webp"]}
            listType="picture"
          >
            <button type="button" className="bg-gray-200 px-2 py-1 rounded-md">
              Chọn ảnh
            </button>
          </Upload>
        </Form.Item>

        <Form.Item
          label="Thời gian bắt đầu"
          name={["applyDate", "start"]}
          rules={[
            { required: true, message: "Vui lòng chọn thời gian bắt đầu!" },
          ]}
        >
          <DatePicker
            showTime
            format="DD-MM-YYYY HH:mm:ss"
            placeholder="Chọn thời gian bắt đầu"
            needConfirm={false}
          />
        </Form.Item>

        <Form.Item
          label="Thời gian kết thúc"
          name={["applyDate", "end"]}
          rules={[
            { required: true, message: "Vui lòng chọn thời gian kết thúc!" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const start = getFieldValue(["applyDate", "start"]);
                if (!start || !value || value.isAfter(start)) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Thời gian kết thúc phải sau thời gian bắt đầu!")
                );
              },
            }),
          ]}
        >
          <DatePicker
            showTime
            format="DD-MM-YYYY HH:mm:ss"
            placeholder="Chọn thời gian kết thúc"
            needConfirm={false}
          />
        </Form.Item>

        <Form.Item
          label="Đối tượng áp dụng"
          name="targetAudience"
          rules={[
            { required: true, message: "Đối tượng áp dụng là bắt buộc!" },
          ]}
        >
          <Input activeBorderColor="#000" hoverBorderColor="#000" />
        </Form.Item>

        <Form.Item
          label="Điều kiện áp dụng"
          name={"conditions"}
          rules={[
            { required: true, message: "Vui lòng nhập điều kiện áp dụng!" },
          ]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item
          label="Phương thức thanh toán"
          name="paymentMethods"
          rules={[{ required: true, message: "Vui lòng chọn phương thức!" }]}
        >
          <Select placeholder="Chọn phương thức thanh toán" mode="tags">
            {PaymentMethods.map((payment) => (
              <Option key={payment.id} value={payment.id}>
                {payment.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Hướng dẫn sử dụng"
          name={"instructions"}
          rules={[
            { required: true, message: "Vui lòng nhập hướng dẫn sử dụng!" },
          ]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item label="Lưu ý" name={"note"}>
          <Input.TextArea />
        </Form.Item>

        <Form.Item
          label="Hiển thị ưu đãi/dịch vụ"
          name="isActive"
          valuePropName="checked"
          initialValue={true} // Mặc định là true
        >
          <SwitchComponent checked={isActive} onChange={handleToggle} />
        </Form.Item>

        <Form.Item>
          <button
            type="submit"
            className="text-white"
            style={{ width: "100%", backgroundColor: "black", height: "3rem" }}
            disabled={loading}
          >
            {!loading
              ? initialValues
                ? "Cập nhật ưu đãi/dịch vụ"
                : "Thêm ưu đãi/dịch vụ"
              : "Đang xử lý..."}
          </button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddOfferServiceForm;
